import { render, staticRenderFns } from "./Photoswipe.vue?vue&type=template&id=3521753f"
import script from "./Photoswipe.vue?vue&type=script&lang=js"
export * from "./Photoswipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports